import {
  ref, watch, computed,
} from '@vue/composition-api'
import store from '@/store'

export default function useDataTable() {
  const items = ref([])
  const refTable = ref(null)
  const limit = ref(10)
  const total = ref(0)
  const currentPage = ref(1)
  const limitOptions = [10, 20, 50, 100]
  const searchQuery = ref('')
  // const searchByTitle = ref("");
  const sortBy = ref('updatedAt')
  const sortTable = ref('sort')
  const isSortDirDesc = ref(true)
  const isLoading = ref(false)
  const selectList = ref([])
  const rootCategoryOptions = ref([])
  const dataMeta = computed(() => {
    const localItemsCount = refTable.value
      ? refTable.value.localItems.length
      : 0
    return {
      from: limit.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: limit.value * (currentPage.value - 1) + localItemsCount,
      of: total.value,
    }
  })

  const refetchData = () => {
    refTable.value.refresh()
  }
  const handleAllSelectToggle = () => {
    if (selectList.value.length === items.value.length) {
      selectList.value = []
    } else {
      selectList.value = items.value.map(item => item._id)
    }
  }
  const isAllSelected = computed(() => {
    if (
      selectList.value.length === items.value.length
      && selectList.value.length !== 0
    ) {
      return true
    } if (selectList.value.length !== 0) {
      return 'intermediate'
    }
    return false
  })
  const isSelected = id => {
    const isSelectedEntry = !!selectList.value.find(itemId => String(itemId) === String(id))
    return isSelectedEntry
  }

  const handleSelectToggle = (val, id) => {
    const select = isSelected(id)
    if (select) {
      selectList.value = selectList.value.filter(itemId => String(itemId) !== String(id))
    } else {
      selectList.value.push(id)
    }
  }
  const fetchCategories = (lang = 'fa', search = '', searchBy = '', parentId = '') => {
    store
      .dispatch('crud/fetchList', {
        queryParams: {
          lang, search, searchBy, parentId,
        },
        endpoint: 'articles-categories',
      })
      .then(response => {
        const allCategoriesItem = {
          title: 'همه دسته بندی ها',
        }
        rootCategoryOptions.value = [
          allCategoriesItem,
          ...response.data.map(item => ({
            _id: item._id,
            title: item.title[lang],
          })),
        ]
      })
      .catch(() => {

      })
  }

  watch([currentPage, limit, searchQuery], () => {
    refetchData()
  })
  watch([items], () => {
    selectList.value = []
  })

  return {
    items,
    limit,
    currentPage,
    total,
    dataMeta,
    limitOptions,
    searchQuery,
    // searchByTitle,
    sortBy,
    isSortDirDesc,
    refTable,
    refetchData,
    isLoading,
    selectList,
    sortTable,
    isAllSelected,
    handleAllSelectToggle,
    isSelected,
    handleSelectToggle,
    fetchCategories,
    rootCategoryOptions,
  }
}
